import {Directive, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {UserRuleReader} from '@ui-app/services/user-rules-reader.service';

@Directive({
    selector: '[isUS]'
})
export class IsUsDirective implements OnInit {

    constructor(
        private viewContainerRef: ViewContainerRef,
        private template: TemplateRef<any>,
        private userRuleReader: UserRuleReader
    ) {
    }

    ngOnInit(): void {
        if (this.userRuleReader.isUSUser) {
            this.viewContainerRef.createEmbeddedView(this.template);
        }

    }
}
